import * as classNames from 'classnames';
import * as React from 'react';
import withStyles, { StyledComponentProps } from 'react-jss';
import { Link } from 'react-router-dom';
import { InjectedApiProps, withApi } from 'src/_context/Api';
import Responsive from 'src/_context/Responsive';
import { InjectedTransitionedContainerProps, withTransitionedContainer } from 'src/_context/TransitionedContainer';
import menuIcon from 'src/assets/icons/novo-menu.svg';
import stylesheet, { directions } from 'src/constants/stylesheet';
import { Language } from 'src/utils/Languages';

export type BurgerProps = {};
const styles = {
    menuIcon: {
        position: 'absolute',
        width: 23,
        transition: 'opacity .4s ease'
        // height: 16,
    },
    menuIconPositioning: {
        ...stylesheet.PostionGutter(1, directions.top | directions.right)
    },
    menuLink: {
        display: 'block',
        pointerEvents: 'initial'
    },
    hide: {
        opacity: 0
    }
};

type Props =
    BurgerProps &
    InjectedTransitionedContainerProps &
    InjectedApiProps &
    StyledComponentProps<keyof typeof styles>;;

class Burger extends React.Component<Props> {
    constructor(props: Props) {
        super(props);
    }

    render() {
        const { classes, transitionedContainer: { move }, apiCtx: { loading } } = this.props;
        return (
            <div className={classNames(classes!.menuIcon, classes!.menuIconPositioning)}>
                <Responsive.Consumer steps={['Mobile']}>
                    <a
                        className={classNames(classes!.menuLink, loading ? classes!.hide : '')}
                        // tslint:disable-next-line:jsx-no-lambda
                        onClick={() => move('menu')}
                        data-routed="true"
                    >
                        <img src={menuIcon} alt="Menu Icon image" />
                    </a>
                </Responsive.Consumer>
                <Responsive.Consumer steps={['AfterMobile']}>
                    <Link
                        to={`/${Language}/projects`}
                        className={classes!.menuLink}
                        // tslint:disable-next-line:jsx-no-lambda
                        onClick={() => move('pages')}
                        data-routed="true"
                    >
                        <img src={menuIcon} alt="Menu Icon image" />
                    </Link>
                </Responsive.Consumer>

            </div>
        );
    }
}

export default withApi(withTransitionedContainer(withStyles(styles)(Burger)));


// WEBPACK FOOTER //
// ./src/components/Burger.tsx